export default __webpack_public_path__ + "static/media/Pretendard-Black.subset.9748a489.woff";